<template>
  <div id="contents">
    <div class="recruit_galaxy_award">
      <div class="recruit_galaxy_award_main">
        <div class="title_area">
          <p class="title">#1年目で</p>
          <p class="title small">ギャラクシー賞受賞！！</p>
        </div>
        <div @click="close" class="back_btn_icon">
          <img src="../assets/img/common/recruit_2021/close.png" alt="close">
        </div>
        <div class="kv">
          <div class="kv_inner">
            <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/kv.png" alt="" width="100%"></p>
            <div class="info">
              <div class="name">
                <p class="ja">梅澤慶光</p>
                <p class="en">Yoshimitsu Umezawa</p>
              </div>
              <p class="desc">亜細亜大学 経済学部を卒業後、2019年に入社。第2制作局 第2制作部。<br>「羽鳥慎一 モーニングショー」を経て、自身で企画したBS朝日「最後のホームルーム（2020年2月OA）」を制作。テレビ、映画、アイドルなどのエンタメを楽しむことが趣味。入社1年目で実現した企画「最後のホームルーム　同窓会をプロデュース」は第57回ギャラクシー賞奨励賞受賞。第36回ATPテレビグランプリ最優秀新人賞受賞。<br>現在の担当番組は、テレビ朝日「ノブナカなんなん?」、テレビ東京特番「ツタの家。」。</p>
            </div>
          </div>
        </div>
        <div class="article">
          <div class="article_inner">
            <ul class="article_list">
              <li class="article_list_item">
                <h3 class="article_list_item_ttl"><span>ギャラクシー賞が</span><span>取れる！といつ手応えを</span><span class="margin_short">感じましたか？</span></h3>
                <div class="content">
                  <div class="image">
                    <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/article_01.png" alt="" width="100%"></p>
                  </div>
                  <div class="text">
                    <p class="ttl">取材してすぐ、<br>「イケるかも！」と感じた。</p>
                    <div class="desc">
                      <p>ギャラクシー賞を受賞した「最後のホームルーム」は、閉校する小学校を舞台に、同窓会をする特番企画。<br>この番組を制作するにあたり、協力してくださる卒業生を探し出したところ、「ユニークで型破りな授業をしていた、名物先生に会いたい」と話されていたんです。<br>そこで栃木県まで向かい、先生を見つけてお話を伺うと、出てくるエピソードがいいものばかり。ドラマチックな物語や児童への愛情、人生の中での後悔など、喜怒哀楽が混ざりあったご経験の数々をお聞きできました。そのときに「すごい人を見つけた！」「これはイケるかも！」と心の中でガッツポーズをした記憶があります。それと同時に、大変な経験をされてきた先生の物語を番組として編集することに対し、責任とプレッシャーも感じました。</p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="article_list_item">
                <h3 class="article_list_item_ttl"><span class="margin_short">制作中、</span><span class="margin_short">大変だったことは？</span></h3>
                <div class="content">
                  <div class="image">
                    <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/article_02.png" alt="" width="100%"></p>
                  </div>
                  <div class="text">
                    <p class="ttl">良くも悪くも、1年目でも、<br>私をディレクターとして<br>尊重してくれること。</p>
                    <div class="desc">
                      <p>「最後のホームルーム」では私がディレクターなので当然、自分で台本も制作しました。実はロケの台本を書くのはこの特番が初めて。先生が持つ「クラスで起こった忘れられない事件」を卒業生に伝えるパートでは、どう演出すればドラマチックに伝えられるのか、ずいぶん悩みました。<br>19時に台本を書き始めて、結局仕上がったのは次の日の5時。9時間かけて書き上げ、先輩にチェックしていただいたのは、結婚式で行われる「メモリプレイ」という目の前で俳優さんが当時を再現する方法を使った台本でした。先輩が「面白いじゃん」と言ってくださったときはホッとしましたね。当日は現場で涙を流す方もいて、ドラマチックなシーンを撮影することができました。</p>
                      <p>今思えば先輩を朝まで待たせてしまい、失礼なことをしたと思いますが、黙って待ってくださる姿勢を見て私も「頑張ろう」と思い、大変な時期も乗り越えられました。</p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="article_list_item">
                <h3 class="article_list_item_ttl"><span>ギャラクシー賞を</span><span>受賞したときの</span><span class="margin_short">気持ちは？</span></h3>
                <div class="content">
                  <div class="text">
                    <p class="ttl">「ギャラクシー賞を取る！」<br>と公言していたので、<br>受賞したときは正直<br>ホッとしました。</p>
                    <div class="desc">
                      <p>「ギャラクシー賞を取る！」という目標は、入社早々から公言していました。自分にプレッシャーをかけて追い込みたかったんです。ですので実際に受賞できたときは、嬉しさもありましたが、正直ホッとしました。もしも受賞できなかったら、ただ調子に乗った若手になっていたので…。</p>
                      <p>私が受賞できたのは、基本的な姿勢を教えてくださった恩師や、「やりたいことは全部やれ」とアドバイスをくださった上司や局長のおかげでもあります。ディレクターとして何を選択したら良いのか悩む私に「発案者なのだからやりたいようにやりなさい」と言っていただいたおかげで、周囲の意見を聞くだけでなく、自分の色を出せたと思っています。</p>
                    </div>
                  </div>
                  <div class="point">
                    <p class="ttl">恩師から教わった、<br>制作時の3つのポイント</p>
                    <ol class="point_list">
                      <li>
                        <p class="num">❶</p>
                        <p class="text">必要な言葉、必要な画トップ3を<br>決めて、それだけは必ずロケで<br>撮ること</p>
                      </li>
                      <li>
                        <p class="num">❷</p>
                        <p class="text">出演者のあらゆる喜怒哀楽を想定<br>して、周到に準備すること</p>
                      </li>
                      <li>
                        <p class="num">❸</p>
                        <p class="text">自分だけの色（オリジナリティ）<br>があるVTR になっているか<br>確認すること</p>
                      </li>
                    </ol>
                  </div>
                </div>
              </li>
              <li class="article_list_item">
                <h3 class="article_list_item_ttl"><span>いい企画の</span><span>条件とは？</span></h3>
                <div class="content">
                  <div class="image">
                    <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/article_03.png" alt="" width="100%"></p>
                  </div>
                  <div class="text">
                    <p class="ttl">1つでもオリジナリティが<br>ある。それがいい企画だと<br>思います。</p>
                    <div class="desc">
                      <p>毎週のように各局でトライアル企画が放送されている今、全てが新しい発想で作られた番組を開発するのはほぼ不可能だと思っています。例えば、私が企画し、テレビ東京で放送された「ツタの家。」は“誰もが経験したことがある普遍的なモノで潜在意識を突く企画”の形に、「ツタの家ってよく見かけるし、どんな人が住んでいるんだろう？」と私が生活するなかで生まれた、ふとした疑問というオリジナリティを足したもの。切り口が新しい、タイトルが秀逸など、何か1つだけでもいいのでオリジナリティを出すと、いい企画になると思います。</p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="article_list_item">
                <h3 class="article_list_item_ttl"><span>学生へのメッセージを</span><span class="margin_short">お願いします。</span></h3>
                <div class="content">
                  <div class="image">
                    <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/article_04.png" alt="" width="100%"></p>
                  </div>
                  <div class="text">
                    <p class="ttl">就活って大変ですよね。<br>私はもう2度と<br>やりたくないです！</p>
                    <div class="desc">
                      <p>私は最初、どうしても「テレビ局」に入りたかったのですが、1年目は全滅。2年目は制作会社まで視野を広げて、ようやくテレビ朝日映像とのご縁が見つかりました。今思えば、2年目はネームバリューやお給料より、私にとっては「本当にやりたい仕事なのか？」「10・20年後にどんな人になっていたいのか？」を突き詰めて就活したから、いい結果に結びついたのだと思います。</p>
                      <p>テレビ朝日映像は1年目でも各局の新規番組企画に応募できる環境があり、「最後のホームルーム」もBS朝日が各社から集めた企画のなかで採用されたもの。募集がなくても、上司に相談すればテレビ局に企画を提案することもできます。真面目に努力して、したたかに戦略を練って、何よりやる気さえあれば、若手にもチャンスがある会社です。<br>大きな野望を持った、学生の皆さんといつか一緒に働けることを楽しみにしています！</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="program">
          <div class="program_inner">
            <h3 class="program_ttl"><span>「最後のホームルーム</span><span>同窓会をプロデュース」</span></h3>
            <p class="content_ttl">番組概要</p>
            <div class="content">
              <div class="top">
                <p class="img"><img src="../assets/img/common/recruit_2024/galaxy_award/program.png" alt="" width="100%"></p>
              </div>
              <div class="bottom">
                <p>明治に開校した歴史を持つ栃木県のある小学校が閉校するのを機に、番組が卒業生の1人に「同窓会をプロデュースさせてほしい」と提案。卒業生は「名物先生に会いたい」、「地元を盛り上げたい」そんな思いを胸に当時のクラスメイトに連絡し、20人程度が同窓会に参加することに。しかし、肝心の名物先生が当日参加するのかまではわからないまま、29年越しに再びクラスメイトが集まる日を迎えた。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_galaxy_award',
  data() {
    return {
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'post_type'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  #contents
    width: 100vw
  .recruit_galaxy_award
    &_main
      width: 91vw
      margin: calc(36.1vw - 41px) auto 0
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -25px
        left: 21px
        z-index: 5
        .title
          @include recruit_font(24px, 20px, .130em)
          color: #fff
          background: #E0AA17
          padding: 11px 3px 13px 9px
          display: table
          &:first-child
            padding: 11px 12px 13px 9px
      .back_btn_icon
        position: absolute
        top: -78px
        left: 0vw
        img
          width: 32px
          height: 32px
      .kv
        &_inner
          .img
            position: relative
            height: 106vw
            margin-bottom: 27px
            img
              position: absolute
              top: 0px
              left: 0px
              z-index: 1
          .info
            margin: 0 20px 46px
            .name
              display: inline-flex
              align-items: center
              margin-bottom: 11px
              padding: 2px 10px 2px 4px
              background: #E0AA17
              .ja
                margin-right: 6px
                @include recruit_font(24px, 1, .176em)
                color: #fff
                @media screen and (max-width: 374px)
                  @include recruit_font(20px, 1, .176em)
              .en
                @include recruit_font(14px, 1, .05em)
                color: #fff
                @media screen and (max-width: 374px)
                  @include recruit_font(12px, 1, .05em)
            .desc
              @include recruit_font(12px, 23px, .14em)
      .article
        margin: 0 20px 60px
        &_inner
          .article_list
            &_item
              margin-bottom: 50px
              &:last-child
                margin-bottom: 0px
              &_ttl
                display: flex
                flex-direction: column
                align-items: flex-start
                margin-bottom: 22px
                span
                  display: inline-block
                  position: relative
                  z-index: 1
                  padding-left: 4px
                  padding-right: 8px
                  @include recruit_font(26px, 38px, -0.01em)
                  color: #fff
                  @media screen and (max-width: 374px)
                    @include recruit_font(21px, 32px, -0.01em)
                  &.margin_short
                    &::after
                      width: calc(100% - 5px)
                  &::after
                    content: ""
                    position: absolute
                    top: 0
                    left: 0px
                    z-index: -1
                    width: 100%
                    height: 40px
                    background: #E0AA17
                    @media screen and (max-width: 374px)
                      height: 34px
              .content
                .image
                  margin-bottom: 23px
                .text
                  .ttl
                    margin-bottom: 24px
                    @include recruit_font(20px, 28px, .136em)
                    color: #E0AA17
                    @media screen and (max-width: 374px)
                      @include recruit_font(17px, 24px, .136em)
                  .desc
                    margin-bottom: 30px
                    p
                      margin-bottom: 23px
                      @include recruit_font(12px, 23px, .14em)
                      &:last-child
                        margin-bottom: 0px
                .point
                  padding: 22px 0
                  background: #E0AA17
                  .ttl
                    margin-bottom: 23px
                    @include recruit_font(16px, 24px, .196em)
                    text-align: center
                    color: #fff
                    @media screen and (max-width: 374px)
                      margin-bottom: 10px
                  &_list
                    padding-left: 28px
                    @media screen and (max-width: 374px)
                      padding-left: 23px
                    li
                      display: flex
                      align-items: center
                      margin-bottom: 13px
                      .num
                        margin-right: 10px
                        @include recruit_font(18px, 1, .196em)
                        color: #fff
                        @media screen and (max-width: 374px)
                          @include recruit_font(16px, 1, .196em)
                      .text
                        @include recruit_font(12px, 23px, .14em)
                        @media screen and (max-width: 374px)
                          @include recruit_font(10px, 19px, .14em)
      .program
        padding: 57px 0 43px
        background: #E0AA17
        &_inner
          .program_ttl
            margin-left: -15px
            margin-bottom: 23px
            display: flex
            flex-direction: column
            align-items: center
            span
              position: relative
              z-index: 2
              display: inline-block
              @include recruit_font(26px, 38px, -0.001em)
              color: #E0AA17
              @media screen and (max-width: 374px)
                @include recruit_font(24px, 38px, -0.001em)
              &:nth-child(1),&:nth-child(2)
                &::after
                  content: ""
                  position: absolute
                  z-index: -1
                  height: 41px
                  background: #fff
              &:nth-child(1)
                &::after
                  top: 0px
                  left: 0px
                  width: 274px
                  @media screen and (max-width: 374px)
                    width: 254px
              &:nth-child(2)
                margin-left: 29px
                &::after
                  top: 0px
                  left: -8px
                  width: 286px
                  @media screen and (max-width: 374px)
                    width: 264px
          .content_ttl
            margin-bottom: 26px
            @include recruit_font(16px, 1, .196em)
            text-align: center
            color: #fff
          .content
            margin: 0 20px
            .top
              margin-bottom: 20px
            .bottom
              p
                @include recruit_font(12px, 23px, .14em)
    .footer
      padding-bottom: 80px
  @media screen and (max-width: 374px)
    .recruit_galaxy_award
      &_main
        margin: calc(39.1vw - 41px) auto 0
        .title_area
          .title
            @include recruit_font(22px, 20px, .04em)
            padding: 7px 3px 9px 9px
            &:first-child
              padding: 7px 12px 9px 9px
        .main_image
          width: 79.8vw
          height: auto
          position: absolute
          top: 8.9vw
        .message
      .footer
</style>



// WEBPACK FOOTER //
// src/components/recruit_galaxy_award.vue